import { Subtopic } from '@shared/domain/subtopic/subtopic.aggregate';
import { httpClient } from '@shared/infrastructure/http/http';
import { SubtopicDto, toSubtopicDomainEntity } from './dto';
import { subtopicService } from '@shared/domain/subtopic/subtopic.service';
import { configuration } from 'configuration';

export const subtopicRepositoryImplementation = {
  getSubtopics: async (
    countryCode: string,
    languageCode: string,
    topicId: number
  ): Promise<Subtopic[]> => {
    const subtopics = await httpClient.get<SubtopicDto[]>(
      `${configuration.api.baseUrl}/api/${countryCode}/topics/${topicId}/subtopics`,
      {
        'Accept-Language': languageCode
      }
    );
    return subtopics.map<Subtopic>((subtopic: SubtopicDto) =>
      subtopicService.createSubtopic(toSubtopicDomainEntity(subtopic))
    );
  },

  getAllSubtopics: async (
    countryCode: string,
    languageCode: string
  ): Promise<Subtopic[]> => {
    const subtopics = await httpClient.get<SubtopicDto[]>(
      `${configuration.api.baseUrl}/api/${countryCode}/subtopics`,
      {
        'Accept-Language': languageCode
      }
    );
    return subtopics.map<Subtopic>((subtopic: SubtopicDto) =>
      subtopicService.createSubtopic(toSubtopicDomainEntity(subtopic))
    );
  },

  getSubtopic: async (
    countryCode: string,
    languageCode: string,
    subtopicId: number
  ): Promise<Subtopic> => {
    const subtopic = await httpClient.get<SubtopicDto>(
      `${configuration.api.baseUrl}/api/${countryCode}/subtopics/${subtopicId}`,
      {
        'Accept-Language': languageCode
      }
    );
    return subtopicService.createSubtopic(toSubtopicDomainEntity(subtopic));
  },

  updateSubtopic: async (
    countryCode: string,
    languageCode: string,
    data: Subtopic
  ): Promise<void> => {
    await httpClient.put(
      `${configuration.api.baseUrl}/api/${countryCode}/subtopics/${data.id}`,
      data || {},
      {
        'Accept-Language': languageCode
      }
    );
  },

  createSubtopic: async (
    countryCode: string,
    languageCode: string,
    data: Subtopic
  ): Promise<void> => {
    await httpClient.post(
      `${configuration.api.baseUrl}/api/${countryCode}/subtopics`,
      data || {},
      {
        'Accept-Language': languageCode
      }
    );
  },

  deleteSubtopic: async (
    countryCode: string,
    subtopicId: number
  ): Promise<void> => {
    await httpClient.delete(
      `${configuration.api.baseUrl}/api/${countryCode}/subtopics/${subtopicId}`
    );
  }
};
